import { Navigate, useLocation } from 'react-router-dom'
import useUserScreens from '../hooks/useUserScreens'

const ScreenGuard = ({ screenId, children }) => {
  const { screens, loading } = useUserScreens()

  const location = useLocation()

  if (loading) return null // or a loader

  const allowedScreenIds = new Set((screens || []).map(s => s.screen_id))

  // screenId can be a single id (number) or a list of ids where
  // having ANY one of them grants access (e.g. Walk-In: 13, 14, or 15)
  const requiredIds = Array.isArray(screenId) ? screenId : [screenId]
  const hasAccess = requiredIds.some(id => allowedScreenIds.has(id))

  if (!hasAccess) {
    return <Navigate to="/not-found" state={{ from: location }} replace />
  }

  return children
}

export default ScreenGuard
